import clsx from "clsx";

import { useCurrentlyUpdatingMetric } from "@features/custom-metrics/hooks/use-currently-updating-metric";
import { useFormulaHistory } from "@features/custom-metrics/hooks/use-formula-history";
import { TertiaryButton } from "@shared/buttons";

interface Props {
  isDisabled: boolean;
  onClear: () => void;
}

export const FormulaActions = ({ isDisabled, onClear }: Props) => {
  const { undoHistory, canClear, resetHistory, canUndo } = useFormulaHistory();
  const { isCreatingNew } = useCurrentlyUpdatingMetric();

  return (
    <div className="flex flex-col">
      <div className="flex justify-end">
        {!isCreatingNew && (
          <TertiaryButton
            className="!h-6 py-1 px-3 flex items-center justify-center"
            onClick={resetHistory}
            disabled={!canUndo}
          >
            RESET
          </TertiaryButton>
        )}
        <TertiaryButton
          className="!h-6 py-1 px-3 flex items-center justify-center gap-2"
          onClick={undoHistory}
          disabled={!canUndo}
        >
          <i className="fa-regular fa-undo" />
          UNDO
        </TertiaryButton>
        <TertiaryButton
          className={clsx("!h-6 py-1 px-3 flex items-center justify-center", {
            "text-mars hover:bg-mars-2": canClear && !isDisabled,
            "text-disabled": isDisabled,
          })}
          onClick={onClear}
          disabled={!canClear || isDisabled}
        >
          CLEAR
        </TertiaryButton>
      </div>
    </div>
  );
};
